import * as THREE from 'three';
import BasicObject from './BasicObject';
import { COLORS_CONST } from '../../helpers/styles';
import {
  DimensionsType,
  LinkingPointObjectType,
  PointTypeLinking,
  SectionsObjetType,
} from '../types';
import { Dimensions } from './Dimensions';

interface Props {
  startPoint: PointTypeLinking;
  endPoint: PointTypeLinking;
}
export default class LinkingPointObject extends BasicObject implements LinkingPointObjectType {
  private widthLine = 0.08;
  private offsetY = 0.02;
  startPoint;
  endPoint;
  material;
  dimensionObject: DimensionsType | null = null;

  constructor(props: Props) {
    const { startPoint, endPoint } = props;
    super();
    this.type = 'line_point';
    this.name = 'line_point';
    this.material = new THREE.MeshBasicMaterial({
      color: COLORS_CONST.black,
      // side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.5,
    });
    this.startPoint = startPoint;
    this.endPoint = endPoint;

    this.buildGeometry();
    setTimeout(() => {
      this.addDimensions();
    }, 500);
  }

  buildGeometry() {
    super.buildGeometry();
    const geometry = new THREE.Geometry();
    // const dir = this.endPoint.clone().sub(this.startPoint).normalize();
    const dir90 = new THREE.Vector3()
      .subVectors(this.endPoint.position, this.startPoint.position)
      .applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI * 0.5)
      .normalize();
    geometry.vertices.push(
      this.startPoint.position
        .clone()
        .add(dir90.clone().multiplyScalar(this.widthLine / 2))
        .setY(this.startPoint.position.y - this.offsetY),
      this.startPoint.position
        .clone()
        .add(
          dir90
            .clone()
            .negate()
            .multiplyScalar(this.widthLine / 2)
        )
        .setY(this.startPoint.position.y - this.offsetY),
      this.endPoint.position
        .clone()
        .add(dir90.clone().multiplyScalar(this.widthLine / 2))
        .setY(this.endPoint.position.y - this.offsetY),
      this.endPoint.position
        .clone()
        .add(
          dir90
            .clone()
            .negate()
            .multiplyScalar(this.widthLine / 2)
        )
        .setY(this.endPoint.position.y - this.offsetY)
    );
    geometry.faces.push(new THREE.Face3(0, 3, 2), new THREE.Face3(0, 1, 3));
    this.geometry = geometry;
  }
  changePositionPoints(pointName: 'startPoint' | 'endPoint', newPosition: THREE.Vector3) {
    this[pointName].position = newPosition;
    this.buildGeometry();
    if (this.dimensionObject) {
      this.dimensionObject.rebuildGroup(this.startPoint.position, this.endPoint.position);
    }
  }
  addDimensions() {
    const parent = this.parent as SectionsObjetType;
    const startPoint = parent.controlPoints[this.startPoint.numberPoint];
    const endPoint = parent.controlPoints[this.endPoint.numberPoint];
    const dim = new Dimensions({ startPoint, endPoint });
    this.dimensionObject = dim;
    this.add(dim);
    // console.log(this)
  }
  hoverOn() {
    this.material.color = new THREE.Color(COLORS_CONST.red);
  }
  hoverOff() {
    this.material.color = new THREE.Color(COLORS_CONST.blue);
  }
  removeMesh() {
    super.removeMesh(this);
    if (this.dimensionObject) {
      this.dimensionObject.removeChildrenGroup();
      this.remove(this.dimensionObject as unknown as THREE.Object3D);
      this.dimensionObject = null;
    }
  }
}
